import { IClcEtmp } from "./clc-etmp";
import { IClcHtmp } from "./clc-htmp";
import { IClcChainStarters } from "./clc-chain-starters";
import { IClcSwapFailure } from "./clc-swapfailure";
import { IClcTargetDecline } from "./clc-target-decline";
import { IClcScoresSummary } from "./clc-scores-summary";
import {IClcScoresMoreDetails } from "./clc-scores-more-details";

export interface IClcScoresDetails {
    centerId: number,
    centerAlias: string,
    eTmps: IClcEtmp[];
    hTmps: IClcHtmp[];
    chainStarters: IClcChainStarters[]; 
    swapFailures: IClcSwapFailure[];
    targetDeclines: IClcTargetDecline[];
    clcScores: IClcScoresSummary;

    adpEtmp: IClcScoresMoreDetails[];
    adpHtmp: IClcScoresMoreDetails[];
    htmda: IClcScoresMoreDetails[];
    undec: IClcScoresMoreDetails[];
    preRevers: IClcScoresMoreDetails[];
    remoteDon: IClcScoresMoreDetails[];
    pairSched: IClcScoresMoreDetails[];
    chainScheduled: IClcScoresMoreDetails[];
}